export default __webpack_public_path__ + "static/media/save.e7f1f5a4.svg";